import React from 'react'; // eslint-disable-line
import i18n from '../../i18n';
import Menu1 from '../../assets/images/menu1.png';
import Menu2 from '../../assets/images/menu2.png';
import Menu3 from '../../assets/images/menu3.png';

class MenuStyleList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedMenuStyle: this.props.selectedMenuStyle,
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(menuStyle) {
        this.setState({
            selectedMenuStyle: menuStyle,
        });

        if (this.props.onChange) {
            this.props.onChange(menuStyle);
        }
    }

    render() {
        return (
            <div className="menu-style-list">
                <div id="menu-type-1" className={`menu-style menu-1 ${this.state.selectedMenuStyle === 1 ? 'selected' : ''}`}>
                    <a href="#menu-style-1" className="menu-style__preview" onClick={this.handleClick.bind(null, 1)}>
                        <img alt="Menu Type Bottom" className="menu-type" src={`${Menu1}`} />
                    </a>
                    <h3 className="menu-style__name">
                        <a href="#menu-style-1">
                            {i18n.t('menu-styles.bottom')}
                        </a>
                    </h3>
                </div>
                <div id="menu-type-2" className={`menu-style menu-2 ${this.state.selectedMenuStyle === 2 ? 'selected' : ''}`}>
                    <a href="#menu-style-2" className="menu-style__preview" onClick={this.handleClick.bind(null, 2)}>
                        <img alt="Menu Type Slide" className="menu-type" src={`${Menu2}`} />
                    </a>
                    <h3 className="menu-style__name">
                        <a href="#menu-style-2">
                            {i18n.t('menu-styles.slide')}
                        </a>
                    </h3>
                </div>
                <div id="menu-type-3" className={`menu-style menu-3 ${this.state.selectedMenuStyle === 3 ? 'selected' : ''}`}>
                    <a href="#menu-style-3" className="menu-style__preview" onClick={this.handleClick.bind(null, 3)}>
                        <img alt="Menu Type Tiled" className="menu-type" src={`${Menu3}`} />
                    </a>
                    <h3 className="menu-style__name">
                        <a href="#menu-style-3">
                            {i18n.t('menu-styles.tiled')}
                        </a>
                    </h3>
                </div>

            </div>
        );
    }
}

export default MenuStyleList;
